import * as React from "react";

function SvgChevronLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.707 13.293l-1.414 1.414L3.586 8l6.707-6.707 1.414 1.414L6.414 8l5.293 5.293z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgChevronLeft;
